<template>
  <div>
    <status-bar :status="status"></status-bar>
    <Answer
    ref="answerCom"
    :class="classObject"
    @answerEnd="onAnswerEnd"
    @refresh="onRefresh"
    ></Answer>
    <Fail
    :precent="precent"
    :class="failView?'':'hide'"
    @refresh="onRefresh"
    ></Fail>
    <Success :class="succView?'':'hide'"  :precent="precent"></Success>
  </div>
</template>
<script>
import StatusBar from '../../components/StatusBar'
import Answer from './components/Answer'
import Fail from './components/Fail'
import Success from './components/Success'
import {changeHistory} from '../../utils/common'
export default {
  name: 'recruitAnswer',
  components: {
    StatusBar,
    Answer,
    Success,
    Fail
  },
  data () {
    return {
      status: '',
      precent: '',
      failView: false,
      succView: false
    }
  },
  created () {
    this.status = this.$route.params.status
    changeHistory()
  },
  mounted () {
    var that = this
    switch (that.status) {
      case '2':
        that.failView = false
        that.succView = false
        break
      case '3':
        that.failView = true
        break
      case '4':
        that.succView = true
        break
    }
  },
  methods: {
    onRefresh () {
      var that = this
      this.$refs.answerCom.getExamInfo().then(function () {
        that.failView = false
        that.succView = false
      })
    },
    onAnswerEnd (data) {
      if (data.right < data.total) {
        this.failView = true
        this.precent = data.right + '/' + data.total
      } else {
        this.precent = data.right + '/' + data.total
        this.succView = true
      }
    }
  },
  computed: {
    classObject: function () {
      return {
        hide: this.failView || this.succView
      }
    }
  }
}
</script>
<style lang="scss" scoped>
// .hide{
//   display: none
// }
// .show{
//   display: block;
// }
</style>



// WEBPACK FOOTER //
// src/pages/recruit-answer/index.vue